// extracted by mini-css-extract-plugin
module.exports = {"doubleboder":"Tsj9M","singleBorder":"urCQF","singleBorderSolid":"w10SM","noBorder":"_d08E","mobileGap":"lyyVx","defenceGap":"D8jn4"};